<template>
  <div id="loanAmount">
    <headNav :routeAddress="address">
      <div slot="headNavText">{{$t('message.immit_loan_quickly')}}</div>
    </headNav>
    <div class="container">
      <div class="withdraw_content">
        <div v-if="loan_type=='jk'">
          <div class="item" @click="popLoan('loan')">
            <div>{{$t('message.with_tx_jkje')}}</div>
            <div style="display: flex;align-items: center">{{loanValueText}}{{coin}}
              <van-icon name="arrow"/>
            </div>
          </div>
          <div class="item">
            <div>{{$t('message.loan_limit')}}</div>
            <div>
              <div @click="popLoan('date')" style="text-align: right;display: flex;align-items: center">
                <span>{{loanDate}}{{$t('message.tian')}}</span>
                <van-icon name="arrow"/>
              </div>
              <!--              <div style="text-align: right;display: flex;align-items: center" v-if="!goPre">-->
              <!--                <span>{{loanDate}}{{day}}</span>-->
              <!--                <van-icon name="arrow"/>-->
              <!--              </div>-->
            </div>
          </div>
          <div class="item">
            <div>{{$t('message.with_tx_jkr')}}</div>
            <div>{{userBank.name}}</div>
          </div>
          <div class="item">
            <div>{{$t('message.ID')}}</div>
            <div>{{userBank.idcard}}</div>
          </div>
          <div class="item">
            <div>{{$t('message.bank_yhmc')}}</div>
            <div>{{userBank.bank_name}}</div>
          </div>
          <div class="item">
            <div>{{$t('message.repay_skzh')}}</div>
            <div @click="setBank()">{{userBank.bank_card}}<van-icon name="arrow" style="vertical-align: middle"/></div>
          </div>
          <!--          <div class="item">-->
          <!--            <div>{{$t('message.loan_data')}}</div>-->
          <!--            <div>{{getTime}}</div>-->
          <!--          </div>-->
          <!--          <div class="item">-->
          <!--            <div>{{$t('message.loan_dq')}}</div>-->
          <!--            <div>{{getTime_dq}}</div>-->
          <!--          </div>-->
          <div class="item">
            <div>{{$t('message.loan_dz')}}</div>
            <div>{{getTotal}}{{coin}}</div>
          </div>
          <div class="item">
            <!--管理费-->
            <div>Phí quản lý</div>
            <div>{{glfee}}{{coin}}</div>
          </div>
          <div class="item">
            <!--利息-->
            <div>Lãi suất</div>
            <div>{{lixi}}{{coin}}</div>
          </div>

          <div class="item">
            <div>{{$t('message.yuqi_fei')}}</div>
            <div>{{yuqi}}</div>
          </div>
          <div class="item">
            <div>{{$t('message.pay_total')}}</div>
            <div>{{repayTotalText}}{{coin}}</div>
          </div>
        </div>
      </div>
      <div style="margin:0 auto;width: 93%;margin-top: 0.51rem;padding-bottom: 30px">
        <van-button block round @click="goLoan" :disabled="isClick" id="btn">{{$t('message.borrow_lijk')}}</van-button>
      </div>
    </div>
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-picker :columns="loanArray" v-if="loanTypes=='loan'" @cancel="onCancel"
                  :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')"
      />
      <van-picker :columns="loanArrayList" v-if="loanTypes=='date'" @cancel="onCancel"
                  :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>

  import {getBorrowMoney, sassagainLoan, sassBorrow, sassLoanQuota, borrowLoan,postUserInfo,getBanksNews} from "../../../ports/port"
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "borrow",
    data() {
      return {
        loanArrayData: [],//所有借款数据
        loanArrayList: [],//获取到的借款列表
        loanArray: [],//放借款额度
        loanArrayElem: 0,//放款额度数组下标
        loanDayArray: [],//放借款天数
        loanTypes: [],
        show: false,
        slideTrue: true,
        loanValue: 0,
        loanDate: 7,
        loanDateText: '',
        loanValueText: '',
        loansetid: '',//借款金额id
        dateStr: '',
        loan_step: 5000,
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        minLoad: '',
        maxLoad: '',
        minDay: '',
        maxDay: '',
        repayTotal: '',//应付总额
        repayTotalText: '',//应付总额文本
        getTotal: '',//实际得到金额
        long: '',//还款期限
        loanList: [],//可借金额数组
        labelPosition: 'right',
        rixi: '',
        yuqi: '',
        dz_total: '',
        disBtn: true,
        showLoading: true,
        goPre: true,//上一层页面
        isClick: false,
        coin: this.$coin,
        loan_type:this.$LOAN_A,
        trueName:'',
        idCard:'',
        userBank:{},
        address:'/home/editBascInfo',
        glfee:'',
        lixi:''
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      let ids = this.$route.query.orderid;
      let company_token = this.$route.query.company_token;
      // 分为通过接口获取额度和固定额度
      if(this.loan_type == 'jk'){
        if (ids != undefined || ids != null) {
          sassLoanQuota({userid: this.tk.userid, company_token: company_token, type: 2})
            .then(res => {
              this.showLoading = false;
              if (res.data.code == 202) {
                this.showDefaultAmounts = true;
              } else {
                res.data.data.list.map((el, i) => {
                  this.loanArray.push(el.amount);
                  this.loanDayArray.push(el.long);
                  this.loanArrayData.push(el);
                });
                this.disBtn = false;
                this.showLoading = false;
                //页面初始数据展示
                this.loanDate = this.loanDayArray[0][0];
                this.loanArrayList = this.loanDayArray[0];
                this.loanValue = this.loanArray[0];
                this.repayTotal = res.data.data.list[0].amount + res.data.data.list[0].amount_fee;
                this.repayTotalText = this.add_comma_toThousands(res.data.data.list[0].amount + res.data.data.list[0].amount_fee);
                this.dz_total = this.add_comma_toThousands(res.data.data.list[0].amount + res.data.data.list[0].amount_fee);
                this.long = this.loanDayArray[0][0];
                this.loansetid = res.data.data.list[0].id;
                this.loanValueText = this.add_comma_toThousands(res.data.data.list[0].amount);

                this.getTotal = this.add_comma_toThousands(res.data.data.list[0].amount - res.data.data.list[0].amount_apply_fee - res.data.data.list[0].amount_manager_fee);
                this.rixi = res.data.data.list[0].rongshi + "%";
                this.yuqi = res.data.data.list[0].yuqi + "%";
                this.glfee = this.add_comma_toThousands((res.data.data.list[0].amount_apply_fee-0) + (res.data.data.list[0].amount_manager_fee-0));
                this.lixi = this.add_comma_toThousands(res.data.data.list[0].amount_fee);
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        } else {
          sassLoanQuota({userid: this.tk.userid, company_token: '', type: 1})
            .then(res => {
              this.showLoading = false;
              if (res.data.code == 202) {
                this.showDefaultAmounts = true;
              } else {
                res.data.data.list.map((el, i) => {
                  this.loanArray.push(el.amount);
                  this.loanDayArray.push(el.long);
                  this.loanArrayData.push(el);
                });
                this.disBtn = false;
                this.showLoading = false;
                //页面初始数据展示
                this.loanDate = this.loanDayArray[0][0];
                this.loanArrayList = this.loanDayArray[0];
                this.loanValue = this.loanArray[0];
                this.repayTotal = res.data.data.list[0].amount + res.data.data.list[0].amount_fee;
                this.repayTotalText = this.add_comma_toThousands(res.data.data.list[0].amount + res.data.data.list[0].amount_fee);
                this.dz_total = this.add_comma_toThousands(res.data.data.list[0].amount + res.data.data.list[0].amount_fee);
                this.long = this.loanDayArray[0][0];
                this.loansetid = res.data.data.list[0].id;
                this.loanValueText = this.add_comma_toThousands(res.data.data.list[0].amount);

                this.getTotal = this.add_comma_toThousands(res.data.data.list[0].amount - res.data.data.list[0].amount_apply_fee - res.data.data.list[0].amount_manager_fee);
                this.rixi = res.data.data.list[0].rongshi + "%";
                this.yuqi = res.data.data.list[0].yuqi + "%";
                this.glfee = this.add_comma_toThousands((res.data.data.list[0].amount_apply_fee-0) + (res.data.data.list[0].amount_manager_fee-0));
                this.lixi = this.add_comma_toThousands(res.data.data.list[0].amount_fee);
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        }
      }else{
        // 默认固定下的额度
        if(this.$Language == 'VN'){
          this.loanValueText ='1.000.000';
          this.loanArray = ['1.000.000','2.000.000','3.000.000','4.000.000','5.000.000'];
          this.loanArrayList = ['7','14'];
          this.long = 7;
        }else{
          this.loanValueText ='1.000';
          this.loanArray = ['1.000','2.000','3.000','4.000','5.000'];
          this.loanArrayList = ['7','14'];
          this.long = 7;
        }
      }
      //获取客户的默认银行卡
      getBanksNews({userid:this.tk.userid})
        .then(res=>{
          if(res.data.code==200){
            let Arr = [];
            Arr = res.data.data.filter((el,i)=>{
              if(el.is_default==1){
                return el
              }
            });
            this.userBank = Arr[0];
          }
        })
    },
    computed: {
      getTime() {
        let time;
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        //date对象的set方法，自动折算
        // date.setDate(Number(this.long)+day);
        // year = date.getFullYear();
        month = Number(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        day = Number(date.getDate()) < 10 ? '0' + date.getDate() : date.getDate();
        // time=year+"-"+month+"-"+day;
        time = day + "-" + month + "-" + year;
        return time;
      },
      getTime_dq() {
        let time;
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        //date对象的set方法，自动折算
        date.setDate(Number(this.long) + day);
        year = date.getFullYear();
        month = Number(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        day = Number(date.getDate()) < 10 ? '0' + date.getDate() : date.getDate();
        // time=year+"-"+month+"-"+day;
        time = day + "-" + month + "-" + year;
        return time;
      },
    },
    methods: {
      setBank(){
        this.$router.push({path:'/home/my/setBanks',query:{prev:'borrow'}});
      },
      onChange(value) {
      },
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = '.' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
      popLoan(a) {
        this.loanTypes = a;
        this.show = true;
        // a=='loan'?this.loanTypes=this.loanArray:this.loanTypes=this.loanDayArray;
        if(this.loan_type == 'jk'){
          if (a == 'date') {
            this.loanArrayList = this.loanDayArray[this.loanArrayElem];
          }
        }
      },
      goLoan() {
        this.isClick = true;
        this.$store.commit('edit', true);//打开全局的loading
        let ids = this.$route.query.orderid;
        // 判断是否是通过接口或者固定额度申请借款
        if(this.loan_type == 'jk'){
          if (ids != undefined || ids != null) {
            sassagainLoan({userid: this.tk.userid, orderid: this.$route.query.orderid, id: this.loansetid})
              .then(res => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (res.data.code == 200) {
                  let that = this;
                  this.$notify({
                    type: 'success',
                    message: this.$t('message.loan_success'),//申请成功
                    onClose: function () {
                      that.$router.push("/schedule");
                      that.isClick = false;
                    }
                  });
                } else {
                  this.$notify({
                    type: 'danger',
                    message: res.data.msg
                  });
                  setTimeout(() => {
                    this.isClick = false;
                  }, 3000);
                }
              })
              .catch(err => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (err.toString().indexOf('timeout') != -1) {
                  this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                }
              })
          } else {
            sassBorrow({userid: this.tk.userid, id: this.loansetid})
              .then(res => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (res.data.code == 200) {
                  if(sessionStorage.getItem('hasRegD')!=null) {
                    if (sessionStorage.getItem('callBackApply') != null) {
                      let str = sessionStorage.getItem('callBackApply');
                      if (str.indexOf("\\'") == -1) {
                        eval(str)
                      } else {
                        let n = str.replaceAll("\\'", "'");
                        eval(n);
                      }
                    }
                  }
                  let that = this;
                  this.$notify({
                    type: 'success',
                    message: this.$t('message.loan_success'),
                    onClose: function () {
                      that.$router.push("/schedule");
                      that.isClick = false;
                    }
                  });

                } else {
                  this.$notify({
                    type: 'danger',
                    message: res.data.msg
                  });
                  setTimeout(() => {
                    this.isClick = false;
                  }, 3000);

                }
              })
              .catch(err => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (err.toString().indexOf('timeout') != -1) {
                  this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                }
              })
          }
        }else{
          if(ids!=undefined||ids!=null){
            sassagainLoan({userid:this.tk.userid,orderid:this.$route.query.orderid})
              .then(res=>{
                if(res.data.code==200){
                  let that = this;
                  this.$notify({
                    type: 'success',
                    message:this.$t('message.loan_success'),//申请成功
                    onClose:function () {
                      that.$router.push("/schedule");
                      that.isClick = false;
                    }
                  });
                }else{
                  this.$notify({
                    type: 'danger',
                    message:res.data.msg
                  });
                  setTimeout(()=>{
                    this.isClick = false;
                  },3000);
                }
              })
          }else{
            sassBorrow({userid:this.tk.userid})
              .then(res=>{
                if(res.data.code==200){
                  let that = this;
                  this.$notify({
                    type: 'success',
                    message:this.$t('message.loan_success'),
                    onClose:function () {
                      that.$router.push("/schedule");
                      that.isClick = false;
                    }
                  });

                }else{
                  this.$notify({
                    type: 'danger',
                    message:res.data.msg
                  });
                  setTimeout(()=>{
                    this.isClick = false;
                  },3000);
                }
              });
          }
        }

      },
      goBack() {
        this.$router.go(-1)
      },
      //关闭选择框
      onCancel() {
        this.show = false;
      },
      //确定选择的值
      onConfirm(value, index) {
        this.show = false;
        if(this.loan_type == 'jk'){
          if (this.loanTypes == 'loan') {
            this.loanValue = value;
            this.loanArrayElem = index;
            this.loanArrayData.forEach((elem, index) => {
              if (elem.amount == value) {
                this.repayTotal = elem.amount + elem.amount_fee;
                this.repayTotalText = this.add_comma_toThousands(elem.amount + elem.amount_fee);
                this.loansetid = elem.id;
                this.getTotal = elem.amount - elem.amount_apply_fee - elem.amount_manager_fee;
                this.loanValueText = this.add_comma_toThousands(elem.amount);
                this.getTotal = this.add_comma_toThousands(elem.amount - elem.amount_apply_fee - elem.amount_manager_fee);
                this.glfee = this.add_comma_toThousands((elem.amount_apply_fee-0) + (elem.amount_manager_fee-0));
                this.lixi = this.add_comma_toThousands(elem.amount_fee);
              }
            })
          } else {
            this.loanDate = value;
            this.long = value;
          }
        }else{
          if (this.loanTypes == 'loan') {
            this.loanValueText = value;
          }else{
            this.loanDate = value;
            this.long = value;
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  #loanAmount {
    background: #F8F8F8;
    min-height: 100vh;
    position: relative;

    .title {
      text-align: center;
      background: white;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px solid #F2F4FB;
      position: relative;

      i {
        position: absolute;
        left: 20px;
        font-size: 20px;
      }
    }

    .withdraw_mount_text {
      text-align: center;
      font-size: 12px;
      margin: 30px 0 10px;
    }

    .withdraw_mount {
      font-size: 14px;
      color: #3a8ee6;
      text-align: center;
      margin: 10px 0 30px;

      span {
        font-size: 28px;
        font-weight: 500;
        margin-right: 6px;

      }
    }

    .withdraw_content {
      width: 93%;
      margin: 6px auto;
      background: #fff;
      padding: 0 15px 15px;
      box-sizing: border-box;
      border-radius: 15px;
      position: relative;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);

      .circle {
        :nth-child(1) {
          position: absolute;
          top: 1.15rem;
          left: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F8F8F8;
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-right: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);
          border-radius: 0 20px 20px 0; /* 左上、右上、右下、左下 */
        }

        :nth-child(2) {
          position: absolute;
          top: 1.15rem;
          right: -1px;
          z-index: 1;
          width: 8px;
          height: 16px;
          background-color: #F8F8F8;
          border-radius: 20px 0 0 20px; /* 左上、右上、右下、左下 */
          border-top: 1px solid rgba(122, 122, 122, 0.1);
          border-left: 1px solid rgba(122, 122, 122, 0.1);
          border-bottom: 1px solid rgba(122, 122, 122, 0.1);

        }
      }

      .withdraw_detail_title {
        font-size: 18px !important;
        font-weight: 600;
      }

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.44rem 0;
        font-size: 14px;
        border-bottom: 1px dotted #E9E9E9;

        div {
          color: gray;
        }

        > div:nth-child(1) {
          color: #8E97A6;
        }
      }

    }

    #btn {
      @include defaultBtn
    }

    .container {
      padding: 1.3rem 0 0;
    }

  }
</style>





// WEBPACK FOOTER //
// src/pages/loanRecord/borrow/borrow.vue